export const SPECIAL_CHARACTER_ID = 'misc';
export const SPECIAL_CHARACTER_LABEL = '#';
